var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 23",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 6C14.4375 4.10152 12.8985 2.5625 11 2.5625C9.10152 2.5625 7.5625 4.10152 7.5625 6V11.5C7.5625 13.3985 9.10152 14.9375 11 14.9375C12.8985 14.9375 14.4375 13.3985 14.4375 11.5V6Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.6875V20.4375",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 11.5C17.1875 13.141 16.5356 14.7148 15.3752 15.8752C14.2148 17.0356 12.641 17.6875 11 17.6875C9.35897 17.6875 7.78516 17.0356 6.62478 15.8752C5.4644 14.7148 4.8125 13.141 4.8125 11.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-Microphone.7992a20de96f2ee9faa3d7bfdd6c1770.svg";
export { ForwardRef as ReactComponent };